export const CHARACTER_INPUT_LIMIT_SHORT = 500;
export const CHARACTER_INPUT_LIMIT_LONG = 4096;
export const CHARACTER_INPUT_LIMIT_TEMPORARY = 2048;
export const PHASE_TITLE_CHARACTER_LIMIT = 128;
